module.exports = __webpack_public_path__ + "img/08.49220b2d.jpg";